
const templateVersion = {
  namespaced: true,
  state: {
    isEcPlus: true
  }
}

export default templateVersion
